<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4">
<div class="modal-header">
  <div class="title">
    <h2 class="modal-title-prefix"><span translate="ODABIRDOKUMENTA.SINGULAR"></span></h2>
  </div>
  <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>
<div class="modal-body">
    <div class="form-group row">
    <div class="col-md-12">
      <yt-dropdown-picklist
        [ModelName]="'odabirdokumenta'"
        [GetName]="'getByurl'"
        [GetParameters]="this.Parameters && this.Parameters.length > 0 ? this.Parameters : null"
        [ModelProperty]="'BrojDokumenta'"
        [OrderBy]="'BrojDokumenta'"
        [AllowAddNew]="false"
        [AllowEdit]="false"
        [Label]="'ODABIRDOKUMENTA.DOKUMENT.SINGULAR'"
        formControlName="OdabirID"
        [ShowHeader]="true"
        [TableColumns]="[ { name: 'BrojDokumenta', label: 'ODABIRDOKUMENTA.BRDOK.SINGULAR', visible: true, canHide: false, width: '20%' }
        , { name: 'Datum', label: 'ODABIRDOKUMENTA.DATDOK.SINGULAR', type: 'ngbDate', format: 'dd.MM.yyyy', visible: true, canHide: false, width: '20%' }
        , { name: 'Komitent', label: 'ODABIRDOKUMENTA.KOMITENT.SINGULAR', visible: true, canHide: false, width: '20%' }
        , { name: 'KomitentMesto', label: 'ODABIRDOKUMENTA.KOMITENTMESTO.SINGULAR', visible: true, canHide: false, width: '20%' }
        , { name: 'Ukupno', label: 'ODABIRDOKUMENTA.UKUPNO.SINGULAR', type: 'number', visible: true, candHide: false, width: '20%' }
        ]"
        >
    </yt-dropdown-picklist>
    <!-- [GetParameters]="[{ Name: 'url', Value: '/fak/predracuni' }]" -->

    </div>
  </div>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary" id="btnSave" (click)="Save()"><span>Kreiraj</span></button>
    <button type="button" class="btn btn-secondary" id="btnClose" (click)="Close()"><span>Zatvori</span></button>
  </div>
</form>

